import React from "react";
import { useSelector } from "react-redux";
import VuiBox from "components/VuiBox";
import FacebookTokenExpirationAlert from "components/FacebookTokenExpirationAlert";
import ShopifyTokenExpirationAlert from "components/ShopifyTokenExpirationAlert";

const GlobalAlerts: React.FC = () => {
  const selectedMerchant = useSelector(
    (state: any) => state.merchants.selectedMerchant
  );

  if (!selectedMerchant?.id) {
    return null;
  }

  return (
    <VuiBox width="100%">
      {selectedMerchant?.facebookConnected && (
        <VuiBox mb={1}>
          <FacebookTokenExpirationAlert />
        </VuiBox>
      )}
      {!selectedMerchant?.hasValidShopifyToken && (
        <VuiBox mb={1}>
          <ShopifyTokenExpirationAlert />
        </VuiBox>
      )}
    </VuiBox>
  );
};

export default GlobalAlerts; 